import { all } from 'redux-saga/effects'
import commonSagas from './common/index'
import userSagas from './user/index'

export default function* rootSaga () {
  yield all([ //合并所有saga
    commonSagas(),
    userSagas(),
  ])
}

